import {Box, Typography, styled} from '@mui/material';

const BeneficiaryName = styled(Typography)(({theme}) => ({
	textTransform: 'uppercase',
	marginBottom: theme.spacing(1),
}));

const InfoIconWrapper = styled(Box)(() => ({
	cursor: 'pointer',
	display: 'inline-flex',
	alignItems: 'center',
}));

export {BeneficiaryName, InfoIconWrapper};
